import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";

interface StatesState {
  showSubscribeWindow: boolean;
}

const initialState: StatesState = {
  showSubscribeWindow: false,
};

// SLICE OBJECT
export const statesSlice = createSlice({
  name: "states",
  initialState,
  reducers: {
    setShowSubscribeWindow: (state, action: PayloadAction<boolean>) => {
      state.showSubscribeWindow = action.payload;
    },
  },
});

// SELECTORS
export const getShowSubscribeWindow = (state: any) =>
  state.states.showSubscribeWindow;
// EXPORTS
export const { setShowSubscribeWindow } = statesSlice.actions;
export default statesSlice.reducer;
